import axios from 'axios'
import { TC_SUPPORT_EMAIL, URL_BACKOFFICE } from '@/configs'
import { ITenant } from '@/types/types'
import { getAuthHeader } from '@/firebase/config'

const { get, post } = axios

const onError = (err: any) => {
  // tslint:disable-next-line:no-console
  console.error(err)
  return false
}

const status = ({ unconfirmed, deactivated }: any) => {
  if (unconfirmed === true) {
    return { id: 'unconfirmed', label: 'Convidado', type: 'is-warning' }
  }
  if (deactivated === true) {
    return { id: 'deactivated', label: 'Desativado', type: 'is-danger' }
  }

  return { id: 'ok', label: 'OK', type: 'is-success' }
}

const ROLES: any = {
  user: 'Usuário',
  manager: 'Gestor',
  admin: 'Administrador',
}

const role = ({ role }: any) => ({ id: role, label: ROLES[role] })

const normalizeUsers = (data: any) => data.users.map(normalizeUser)
const normalizeUser = (user: any) => ({
  ...user,
  status: status(user),
  role: role(user),
})

export const findUsers = async (tenantName: string) =>
  get(
    `${URL_BACKOFFICE}/accounts/users?tenant=${tenantName}&page=1&itemsPerPage=2000`,
    await getAuthHeader()
  )
    .then(({ data }: any) => data)
    .then(normalizeUsers)
    .catch(onError)

export const findUserTenantByEmail: (
  email: string
) => Promise<ITenant[]> = async (email: string) =>
  get(`${URL_BACKOFFICE}/users?email=${email}`, await getAuthHeader())
    .then(({ data: { users } }) => users || [])
    .catch(onError)

export const getSupportUserCurrentLocale: () => Promise<ITenant> = () =>
  findUserTenantByEmail(TC_SUPPORT_EMAIL).then(
    ([tenant]) => tenant || { tenantName: '' }
  )

export const sendInvite = async (tenantName: string, emails: string[]) =>
  post(`${URL_BACKOFFICE}/email/confirmation?send=true`, {
    tenant: tenantName,
    users: emails,
    ...(await getAuthHeader()),
  }).catch(onError)

export default {
  sendInvite,
  findUsers,
  findUserTenantByEmail,
  getSupportUserCurrentLocale,
}
